/**
 * Fetches card query results for editor preview (inline payload or WS wait).
 * Used by chart and table preview loaders — not card CRUD (`updateCard` / `createCard`).
 *
 * @see Docs/analytics-gql-crud-naming-audit.md — card body persistence uses `updateCard`.
 *
 * Older AppSync schemas omit `requestId` / `requester` on `getItem.cardData` — use
 * {@link fetchGetCardDataItem} which retries with {@link queryGetCardDataWithoutRequestTracing}.
 * Schemas without `pagination` use {@link queryGetCardDataWithoutPagination} on retry.
 */
export const queryGetCardDataWithoutRequestTracingAndPagination = `
	query getCardData(
		$cardId: ID!
		$timeDimension: TimeDimensionsInput
		$accountId: ID
		$refresh: Boolean
		$dataConfig: CardDataConfigInput
	) {
		getItem {
			cardData(
				cardId: $cardId
				timeDimension: $timeDimension
				accountId: $accountId
				refresh: $refresh
				dataConfig: $dataConfig
			)
		}
	}
`;

export const queryGetCardDataWithoutRequestTracing = `
	query getCardData(
		$cardId: ID!
		$timeDimension: TimeDimensionsInput
		$accountId: ID
		$refresh: Boolean
		$pagination: PaginationInput
		$dataConfig: CardDataConfigInput
	) {
		getItem {
			cardData(
				cardId: $cardId
				timeDimension: $timeDimension
				accountId: $accountId
				refresh: $refresh
				pagination: $pagination
				dataConfig: $dataConfig
			)
		}
	}
`;

export const queryGetCardData = `
	query getCardData(
		$cardId: ID!
		$timeDimension: TimeDimensionsInput
		$accountId: ID
		$refresh: Boolean
		$pagination: PaginationInput
		$dataConfig: CardDataConfigInput
		$requestId: ID!
		$requester: ID!
	) {
		getItem {
			cardData(
				cardId: $cardId
				timeDimension: $timeDimension
				accountId: $accountId
				refresh: $refresh
				pagination: $pagination
				dataConfig: $dataConfig
				requestId: $requestId
				requester: $requester
			)
		}
	}
`;

export const queryGetCardDataWithoutPagination = `
	query getCardData(
		$cardId: ID!
		$timeDimension: TimeDimensionsInput
		$accountId: ID
		$refresh: Boolean
		$dataConfig: CardDataConfigInput
		$requestId: ID!
		$requester: ID!
	) {
		getItem {
			cardData(
				cardId: $cardId
				timeDimension: $timeDimension
				accountId: $accountId
				refresh: $refresh
				dataConfig: $dataConfig
				requestId: $requestId
				requester: $requester
			)
		}
	}
`;
